<template>
    <v-container>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <app-title>Finalización de actualización de información</app-title>
                    </v-card-title>
                    <v-card-text>
                        <h5>Su solicitud ha sido recibida</h5>
                        <p>Por favor confirmela ingresando el código de 4 dígitos que fue enviado a su nuevo correo</p>
                        <v-text-field
                            v-model="code"
                            label="Código"
                            :error-messages="codeErrors"
                            @input="$v.code.$touch()"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout>
                            <v-flex>
                                <v-btn block color="primary" class="mb-5" @click="validateCode">Confirmar Código</v-btn>
                                <v-divider></v-divider>
                                <v-btn block color="secondary" @click="$router.push({ name: 'home' })">Cancelar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import authRepository from '../../../repositories/auth.repository';
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators';
export default {
    data: () => ({
        code: ''
    }),
    validations: {
        code: {
            required,
            numeric,
            minLength: minLength(4),
            maxLength: maxLength(4)
        }
    },
    computed: {
        codeErrors() {
            const errors = [];

            !this.$v.code.required && errors.push('El código es requerido');
            !this.$v.code.numeric && errors.push('El código es numérico');
            !this.$v.code.minLength && errors.push('El código es de mínimo 4 digitos');
            !this.$v.code.maxLength && errors.push('El código es de máximo 4 digitos');

            return errors;
        }
    },
    methods: {
        async validateCode() {
            this.$v.$touch();

            if(this.$v.$invalid) return;

            const ar = {...authRepository};

            const { data } = await ar.confirmCode(this.user.id, this.code);

            if(data.status) {

                const user = {...this.user, email: data.updateRequest.email};

                this.$store.commit('SET_USER', user);

                toastr.success('Información actualizada');
                this.$router.push({ name: 'home' });
            } else {
                toastr.error(data.msg);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyAccount/ChangeEmail/UpdateEmailConfirm.vue